import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthTokenService } from './auth-token.service';
import { IAuthResult } from './auth.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public SERVICE_URL = `${environment.baseUrls.serviceSecurity}/api/authenticate`;
  constructor(
    private authTokenService: AuthTokenService,
    private http: HttpClient
  ) {}
  /**
   * Login and authenticate user then set api token on success
   */
  public login(username: string, password: string) {
    return this.authenticate(username.toLocaleLowerCase().trim(), password);
    /*return forkJoin([authenticate$]).pipe(
      tap(([authenticate]) => {
        this.authTokenService.setTokens(authenticate);
      }),
      shareReplay()
    );*/
  }

  public authenticate(username: string, password: string) {
    return this.http.post<IAuthResult>(this.SERVICE_URL, {
      username: username,
      password: password,
    }, this.getOptions()
    );
  }
  private getOptions(
    params?: {},
    headerParams?: {},
  ) {
    const requestOptions = {
      headers: {},
      params: params,
    };
    let headers = new HttpHeaders();
    headers = headers.append('Strict-Transport-Security', 'max-age=31536000;includeSubdomains');
    headers = headers.append('document.cookie', 'Secure;HttpOnly');
    headers = headers.append('X-Content-Type-Options', 'nosniff');
    headers = headers.append('Cache-Control', 'no-cache');
    headers = headers.append('X-Frame-Options', 'SAMEORIGIN');
    requestOptions.headers = headers;
    return requestOptions;
  }
  public isUserAuthenticated() {
    const refreshToken = this.authTokenService.getValidRefreshToken();

    if (refreshToken !== null) {
      return of(true);
    }

    return of(false);
  }
}
